import React from 'react';
import { Toast } from 'react-bootstrap';

const fadeInUp = `
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;


interface MyToastProps {
  show: boolean;
  message: string;
  variant?: 'success' | 'danger' | 'warning' | 'info';
  onClose: () => void;
  delay?: number;
}

const getBgColor = (variant: string) => {
  switch (variant) {
    case 'success':
      return '#28a745';
    case 'danger':
      return '#dc3545';
    case 'warning':
      return '#ffc107';
    case 'info':
    default:
      return '#17a2b8';
  }
};

const MyToast: React.FC<MyToastProps> = ({
  show,
  message,
  variant = 'info',
  onClose,
  delay = 3000,
}) => {
  return (
    <>
      <style>{fadeInUp}</style>
      <div
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          zIndex: 9999,
          minWidth: 300,
          padding: '10px',
        }}
      >
        <Toast
          onClose={onClose}
          show={show}
          delay={delay}
          autohide
          style={{
            backgroundColor: getBgColor(variant),
            color: '#fff',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            padding: '20px 25px',
            border: 'none',
            animation: 'fadeIn 0.5s ease-in-out',
            maxWidth: '100%', // Ensure the width of the toast doesn't exceed the available space
            wordBreak: 'break-word', // Handle long words
          }}
        >
          <Toast.Body
            style={{
              whiteSpace: 'normal', // Ensure content wraps to the next line
              wordBreak: 'break-word', // Break long words if necessary
              overflowWrap: 'break-word', // Handle words that are too long
            }}
          >
            {message}
          </Toast.Body>
        </Toast>
      </div>
    </>

  );
};

export default MyToast;
